import React from "react";

const projects = [
  {
    title: "Graphlete.pro",
    description:
      "Data visualization platform with graphical representation capabilities.",
    image: "", // Add image path if you have it
    url: "http://graphlete.pro",
  },
  {
    title: "Qura.ai",
    description: "AI-driven platform for analytics or insights.",
    image: "", // Add image path if available
    url: "http://qura.ai",
  },
  {
    title: "Mood-logging Application",
    description: "Platform for tracking and analyzing mood patterns.",
    image: "", // Optional
    url: "",
  },
  {
    title: "Notes-linking Platform with Vector Search",
    description:
      "Sophisticated note-taking application with advanced search capabilities.",
    image: "", // Optional
    url: "",
  },
  {
    title: "AI-Based Classroom",
    description:
      "A comprehensive educational platform with integrated AI for real-time insights, tracking, and management.",
    image: "/images/ai-classroom.jpg",
    url: "https://front-end-seven-teal.vercel.app/",
  },
  {
    title: "Blockchain dApp",
    description:
      "A decentralized application (dApp) built for smart contract deployment and token interaction using Solidity and TypeScript.",
    image: "/images/blockchain-dapp.jpg",
    url: "#", // Replace when deployed
  },
];

const Portfolio = () => {
  return (
    <section
      className="py-16 px-6 md:px-12 max-w-7xl mx-auto bg-white"
      id="portfolio"
    >
      <div className="text-center mb-12">
        <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Portfolio</h2>
        <p className="text-gray-600 text-lg">
          Check out some of the exciting projects we've built.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
        {projects.map((project, idx) => (
          <div
            key={idx}
            className="bg-gray-100 rounded-xl shadow hover:shadow-lg overflow-hidden transition"
          >
            {project.image && (
              <img
                src={project.image}
                alt={project.title}
                className="w-full h-60 object-cover"
              />
            )}
            <div className="p-6">
              <h3 className="text-2xl font-semibold mb-2 text-gray-800">
                {project.title}
              </h3>
              <p className="text-gray-600 mb-4">{project.description}</p>
              {project.url && (
                <a
                  href={project.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
                >
                  View Project
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Portfolio;
